import { IVendorState } from '@/store/vendor';
import { IVendorMutations } from './mutations.types';
import { IVendorData } from '@/models';

export const mutations: IVendorMutations = {
  SET_VENDORS(state: IVendorState, payload: IVendorData[]): void {
    state.vendors = payload;
  },

  ADD_VENDOR(state: IVendorState, payload: IVendorData): void {
    state.vendors.push(payload);
  },

  UPDATE_VENDOR(state: IVendorState, payload: IVendorData): void {
    const index = state.vendors.findIndex(
      (vendor: IVendorData) => vendor.id === payload.id
    );

    state.vendors.splice(index, 1, payload);
  },

  REMOVE_VENDOR(state: IVendorState, payload: string): void {
    const index = state.vendors.findIndex(
      (vendor: IVendorData) => vendor.id === payload
    );

    state.vendors.splice(index, 1);
  }
};
